module.exports = __webpack_public_path__ + "img/icon-noChat.cd55dad0.png";